<template>
  <div>
  <!-- ตาราง Assets ใน report -->
  <CCard class="bg-style2" style="min-height:200px;">
      <CCardHeader class="bg-gradient-dark text-white" style="border-top-left-radius:1rem;border-top-right-radius:1rem">
        <span class="font-weight-bold h6">
          <CIcon :name="icon" size="lg"/> {{ caption }}
        </span>

      </CCardHeader>
      
      <CCardBody>
        <CRow>
          <CCol>
              <CDataTable
                class="custom-datatable"
                :hover="true"
                :bordered="true"
                :small="true"
                :fixed="true"
                :fields="fields"
                :items="sortedPendingRequests"
                :items-per-page="small ? 50 : 5"
                pagination
              >
              <template #index="{index}">
                <td >
                  <label>{{ index + 1 }}</label>
                </td>
              </template>

              <template #description="{item}">
                <td >
                  <span>{{ item.description }}</span>
                </td>
              </template>

              <template #assetName="{item}">
                <td >
                  <span>{{ item.assetName }}</span>
                </td>
              </template>

              <template #amount="{item}">
                <td >
                  <span>{{ item.amount }}</span>
                </td>
              </template>

              <template #status="{item}">
                <td >
                  <span>{{ item.status }}</span>
                </td>
              </template>

              <template #action="{ item }">
                <td style="text-align:center; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                  <CButton
                    v-if="item.status === 'pending' && canEditAssets"
                    v-c-tooltip.hover.click="'อนุมัติ'"
                    class="mr-1"
                    size="sm"
                    color="success"
                    shape="pill"
                    variant="outline"
                    @click="confirmApprove(item)"
                  >
                    <CIcon name="cil-check" />
                  </CButton>
                  <CButton
                    v-if="item.status === 'pending' && canEditAssets"
                    v-c-tooltip.hover.click="'ปฏิเสธ'"
                    class="mr-1"
                    size="sm"
                    color="danger"
                    shape="pill"
                    variant="outline"
                    @click="confirmReject(item)"
                  >
                    <CIcon name="cil-x" />
                  </CButton>
                </td>
              </template>
            </CDataTable>
          </CCol>
        </CRow>
          <div class="card-header-actions">
            <CButton 
              v-c-tooltip.hover.click="'เพิ่ม'"
              color="info" 
              size="sm" 
              shape="pill"
              variant="outline"
              class="mt-2"
              @click="openModal"
              :disabled="!canEditAssets"
            >
              <CIcon name="cil-plus" class="me-2"/>
            </CButton>
          </div>
      </CCardBody>
    </CCard>
    <!-- Modal เพิ่ม Assets -->
    <CModal
      title="กรุณาเลือกสินทรัพย์"
      :show.sync="showModal"
      size="lg"
      :centered="true"
      class="modal-rounded"
    >
      <template #body-wrapper>
        <div style="max-height: 400px; overflow-y: auto; padding: 1rem;">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" :disabled="!canEditAssets"/>
                </th>
                <th>ชื่อ Asset</th>
                <th>คงเหลือ</th>
                <th>จำนวนที่ต้องการ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="asset in filteredAssets" :key="asset._id" :class="{ 'inactive-row': asset.amount <= 0 }">
                <td class="text-start">
                  <input type="checkbox" 
                         :value="asset._id" 
                         v-model="selectedAssetIds" 
                         :disabled="asset.amount <= 0 || !canEditAssets"/>
                </td>
                <td>{{ asset.titleText }}</td>
                <td>{{ asset.amount }}</td>
                <td>
                  <input
                    type="number"
                    v-model.number="selectedAssetAmounts[asset._id]"
                    :max="asset.amount"
                    min="1"
                    class="form-control form-control-sm"
                    @keydown="blockInvalidInput($event)"
                    @input="autoSelectAsset(asset)"
                    :disabled="!canEditAssets"
                  />
                </td>
              </tr>
              <tr v-if="filteredAssets.length === 0">
                <td colspan="4" class="text-center text-muted">ไม่มี Assets ให้เลือก</td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <template #footer>
        <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="closeModal">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="sm"/> CANCEL </span> 
        </CButton>
        <CButton size="sm" color="success" shape="pill" variant="outline" 
                @click="addAssetsToReport" 
                :disabled="selectedAssetIds.length===0 || !canEditAssets">
          <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="sm"/> SUBMIT </span>
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';

export default {
  name: "FoodAssetCard",
  props: {
    caseId: { type: String, required: true },
    icon: { type: String, default: "cil-restaurant" },
    caption: { type: String, default: "Assets" }
  },
  data() {
  return {
    showModal: false,
    selectedCategoryId: '',
    selectedAssetIds: [],
    selectedAssetAmounts: {},
    selectAll: false,
    fields: [
        {key: "index", label: "#", _style: 'width:20px; text-align: center'},
        {key: "assetName", label: "ชื่อสินทรัพย์"},
        {key: "amount", label: "จำนวน" },
        {key: "status", label: "สถานะคำขอ"},
        {key: "action", label: "การจัดการ" , _style: 'width:220px; text-align: center'},
    ],
    pendingRequests: [],
    // user: null,
  };
},
  computed: {
    ...mapGetters({ 
      caseData: 'Dashboard2/case',
      assets: 'Assets/assets',
      reports: 'Dashboard/reports',
      users: "Auth/users",
      selectedUser: "Auth/selectedUser",
    }),
    isCaseOpen() {
      return this.caseData && this.caseData.caseManagement
        ? this.caseData.caseManagement.isOpen
        : false;
    },

    allRoles() {
      return this.selectedUser?.authen?.flatMap(a => a.roles) || [];
    },

    canEditAssets() {
      return this.isCaseOpen && this.allRoles.includes("1") || this.allRoles.includes("3");
    },
    categories() { 
      return this.$store.state.Assets.category || []; 
    },
    allAssets() { 
      return this.$store.state.Assets.assets || []; 
    },
    filteredAssets() {
      return this.allAssets
        .filter(a => a.status === 'active')
        .map(a => ({
          _id: a._id,
          titleText: Array.isArray(a.title) ? a.title.map(t => t.value).join(", ") : a.title || '-',
          amount: a.amount,
          categoryId: a.categoryId
        }));
    },

    // เรียง pending ก่อน approved/rejected และรายการใหม่อยู่บนสุดในแต่ละกลุ่ม
    sortedPendingRequests() {
      const statusOrder = (s) => (s === 'pending' ? 0 : 1);
      return [...this.pendingRequests].sort((a, b) => {
        const diffStatus = statusOrder(a.status) - statusOrder(b.status);
        if (diffStatus !== 0) return diffStatus;
        // เรียงตาม createdAt (ใหม่สุดก่อน)
        const timeA = new Date(a.createdAt || 0).getTime();
        const timeB = new Date(b.createdAt || 0).getTime();
        return timeB - timeA;
      });
    },
  },
  watch: {
    selectedAssetIds(val) {
      this.selectAll = val.length === this.filteredAssets.filter(a => a.amount>0).length;
      // ensure amounts exist for newly selected assets and clamp to available
      val.forEach(id => {
        const asset = this.filteredAssets.find(a => a._id === id);
        if (!asset) return;
        const current = Number(this.selectedAssetAmounts[id] || 0);
        if (!current || current < 1) {
          this.$set(this.selectedAssetAmounts, id, 1);
        } else if (current > asset.amount) {
          this.$set(this.selectedAssetAmounts, id, asset.amount);
        }
      });
      // remove amounts for unselected assets to keep state clean
      Object.keys(this.selectedAssetAmounts).forEach(k => {
        if (!val.includes(k)) this.$delete(this.selectedAssetAmounts, k);
      });
    },

    assets: {
      handler() {
        this.refreshPendingRequests()
      },
      deep: true,
      immediate: true
    },
     reports: {
        handler() {
          this.refreshPendingRequests()
        },
        deep: true,
        immediate: true
      },
      users: {
        handler(val) {
          this.user = val[0] || null;
        },
        deep: true,
        immediate: true
      },

      user: {
        handler() {
          this.canEditAssets;
        },
        deep: true,
        immediate: true
      },
      selectedUser: {
        handler() {
          this.canEditAssets; 
        },
        deep: true,
        immediate: true
      }
  },
  methods: {
    getCategoryTitle(cat) {
      if (!cat) return '-';
      return Array.isArray(cat.title) ? cat.title.map(t => t.value).join(", ") : cat.title || '-';
    },
    getCategoryTitleById(id) { 
      const cat = this.categories.find(c=>c._id===id); 
      return this.getCategoryTitle(cat); 
    },
    blockInvalidInput(e) {
      if (
        e.key === '-' ||
        e.key.toLowerCase() === 'e' ||
        (e.key === '0' && (!e.target.value || e.target.selectionStart === 0))
      ) {
        e.preventDefault();
      }
    },
    autoSelectAsset(asset) {
      // clamp and sync the numeric input value with available stock
      let val = Number(this.selectedAssetAmounts[asset._id]) || 0;
      if (val <= 0) {
        // treat empty/zero as unselected
        this.$delete(this.selectedAssetAmounts, asset._id);
        this.selectedAssetIds = this.selectedAssetIds.filter(id => id !== asset._id);
        return;
      }
      if (val > asset.amount) val = asset.amount;
      this.$set(this.selectedAssetAmounts, asset._id, val);
      if (!this.selectedAssetIds.includes(asset._id)) this.selectedAssetIds.push(asset._id);
    },
    openModal() {
      if (!this.canEditAssets) return;
      this.showModal = true;
      this.selectedCategoryId = '';
      this.selectedAssetIds = [];
      this.selectedAssetAmounts = {};
      this.selectAll = false;
      this.$store.dispatch("Assets/assets");
      this.$store.dispatch("Assets/category");
    },
    closeModal() {
      this.showModal = false;
      this.selectedCategoryId = '';
      this.selectedAssetIds = [];
      this.selectedAssetAmounts = {};
      this.selectAll = false;
    },
    toggleSelectAll() {
      if(this.selectAll){
        this.selectedAssetIds = this.filteredAssets.filter(a=>a.amount>0).map(a=>a._id);
        // set default amount of 1 for each selected asset (clamped)
        this.selectedAssetIds.forEach(id => {
          const asset = this.filteredAssets.find(a => a._id === id);
          if (!asset) return;
          const defaultAmount = Math.min(1, asset.amount) || 1;
          this.$set(this.selectedAssetAmounts, id, defaultAmount);
        });
      } else {
        this.selectedAssetIds = [];
        this.selectedAssetAmounts = {};
      }
    },
    async addAssetsToReport() {
      if (!this.canEditAssets || !this.selectedAssetIds.length) return;

      const selectedAssets = this.filteredAssets.filter(a => this.selectedAssetIds.includes(a._id));
      // validate amounts do not exceed available stock
      const invalid = [];
      this.selectedAssetIds.forEach(id => {
        const asset = this.filteredAssets.find(a => a._id === id);
        const qty = Number(this.selectedAssetAmounts[id] || 0);
        if (!asset) return;
        if (!qty || qty < 1) invalid.push({ id, reason: 'empty' });
        else if (qty > asset.amount) invalid.push({ id, reason: 'exceed', available: asset.amount, requested: qty });
      });
      if (invalid.length) {
        const first = invalid[0];
        const asset = this.filteredAssets.find(a => a._id === first.id);
        const msg = first.reason === 'empty'
          ? `คุณต้องใส่จำนวนที่ต้องการสำหรับ ${asset ? asset.titleText : 'asset'}`
          : `จำนวนสำหรับ ${asset ? asset.titleText : 'asset'} เกินจำนวนคงเหลือ (${first.requested} > ${first.available})`;
        await Swal.fire({ icon: 'warning', title: 'จำนวนไม่ถูกต้อง', text: msg });
        return;
      }

      try {
        await this.$store.dispatch("Dashboard/addAssetToReport", {
          reportId: this.caseId,
          assetIds: this.selectedAssetIds
        });

        await Promise.all(this.selectedAssetIds.map(id => {
          const amount = Number(this.selectedAssetAmounts[id] || 1);
          return this.$store.dispatch("Assets/update", {
            _id: id,
            stockChange: {
              amount: amount,
              state: null,
              account: 'system',
              report: this.caseId,
              status: 'pending'
            }
          });
        }));

        selectedAssets.forEach(asset => {
          this.$store.dispatch("Dashboard2/logCaseAction", {
            caseId: this.caseId,
            by: "ผู้ใช้ระบบ",
            assetId: asset._id,
            assetAction: "added",
            reason: `เพิ่ม ${asset.titleText}`
          });
        });

        this.closeModal();
        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'Assets ถูกเพิ่มเรียบร้อย',
          timer: 2000,
          showConfirmButton: false
        });

      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: 'error',
          title: 'ผิดพลาด',
          text: 'ไม่สามารถเพิ่ม Assets',
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
    async removeAsset(asset) {
      if (!this.canEditAssets) return;

      const assetTitle = asset.titleText || '-';
      const assetAmount = asset.amount || 0;

      const result = await Swal.fire({
        title: 'คุณแน่ใจหรือไม่?',
        text: `Asset ${assetTitle} จำนวน ${assetAmount} จะถูกลบ`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ลบทันที',
        cancelButtonText: 'ยกเลิก'
      });

      if (!result.isConfirmed) return;

      try {
        await this.$store.dispatch("Dashboard/removeAssetFromReport", {
          reportId: this.caseId,
          assetIds: [asset._id]
        });

        const assetInStore = this.$store.state.Assets.assets.find(a => a._id === asset._id);
        if (assetInStore) {
          const updatedHistory = (assetInStore.history || []).filter(h => h.report !== this.caseId);
          await this.$store.dispatch("Assets/update", {
            _id: asset._id,
            history: updatedHistory
          });
        }

        const report = this.$store.state.Dashboard.reports.find(r => r._id === this.caseId);
        if (report) report.assets = report.assets.filter(r => r.assetId !== asset._id);

        this.$store.dispatch("Dashboard2/logCaseAction", {
          caseId: this.caseId,
          by: "ผู้ใช้ระบบ",
          assetId: asset._id,
          assetAction: "removed",
          reason: `ลบ ${assetTitle}`
        });

        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'ลบ Assetsเรียบร้อยแล้ว',
          timer: 1500,
          showConfirmButton: false
        });

      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: 'error',
          title: 'ผิดพลาด',
          text: 'ไม่สามารถลบ Assets',
          timer: 2000,
          showConfirmButton: false
        });
      }
    },
  // อยู่นอก computed → ไปไว้ใน methods
refreshPendingRequests() {
  const requests = [];
  const report = this.reports.find(r => r._id === this.caseId);
  
  this.assets.forEach(asset => {
    (asset.history || []).forEach((h, idx) => {
      if (h.report === this.caseId && h.status !== 'rejected') {
        requests.push({
          _id: asset._id,
          description: report ? report.description : '',
          assetName: Array.isArray(asset.title) ? asset.title.map(t => t.value).join(", ") : asset.title,
          amount: h.amount,
          status: h.status,
          report: h.report,
          historyIndex: idx,
          createdAt: h.createdAt || new Date(0) // ใช้ createdAt จาก history
        });
      }
    });
  });
  
  this.pendingRequests = requests;
},



    confirmApprove(item) {
      Swal.fire({
        title: 'คุณต้องการอนุมัติสินทรัพย์นี้?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'อนุมัติ',
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#28a745',
      }).then(result => {
        if (result.isConfirmed) {
          this.approve(item)
        }
      })
    },

    confirmReject(item) {
      Swal.fire({
        title: 'คุณต้องการไม่อนุมัติสินทรัพย์นี้?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ไม่อนุมัติ',
        cancelButtonText: 'ยกเลิก',
        confirmButtonColor: '#dc3545',
      }).then(result => {
        if (result.isConfirmed) {
          this.reject(item)
        }
      })
    },

    async approve(item) {
      try {
        const asset = this.assets.find(a => a._id === item._id)
        if (!asset) return
        const currentStock = Number(asset.amount || 0)
        const requestAmount = Number(item.amount || 0)
        if (!Number.isFinite(requestAmount) || requestAmount < 1) {
          await Swal.fire('จำนวนไม่ถูกต้อง', 'กรุณาตรวจสอบจำนวนที่ต้องการอีกครั้ง', 'warning')
          return
        }
        if (requestAmount > currentStock) {
          await Swal.fire({
            icon: 'warning',
            title: 'จำนวนสินทรัพย์เหลือไม่เพียงพอ',
            text: `กรุณาตรวจสอบจำนวนที่ต้องการอีกครั้ง`
          })
          return
        }

        // อัปเดตเฉพาะ history รายการที่เลือก (ตาม index)
        const updatedHistory = Array.isArray(asset.history) ? [...asset.history] : []
        const idx = Number(item.historyIndex)
        if (Number.isInteger(idx) && updatedHistory[idx] && updatedHistory[idx].report === item.report) {
          updatedHistory[idx] = { ...updatedHistory[idx], status: 'approved', state: false }
        } else {
          // fallback: อัปเดตรายการแรกที่ pending ของ report นี้
          const firstIdx = updatedHistory.findIndex(h => h.report === item.report && h.status === 'pending' && Number(h.amount || 0) === requestAmount)
          if (firstIdx >= 0) {
            updatedHistory[firstIdx] = { ...updatedHistory[firstIdx], status: 'approved', state: false }
          } else {
            await Swal.fire('ไม่พบรายการ', 'ไม่พบคำขอที่ต้องการอนุมัติ', 'warning')
            return
          }
        }
        await this.$store.dispatch('Assets/update', { _id: asset._id, history: updatedHistory })
        await this.$store.dispatch('Assets/assets')
        await this.$store.dispatch('Dashboard2/logCaseAction', {
          caseId: item.report,
          by: "ผู้ใช้ระบบ", 
          assetId: asset._id,
          assetAction: "approved",
          reason: `อนุมัติ ${Array.isArray(asset.title) ? asset.title.map(t=>t.value).join(", ") : asset.title}`
        })

        this.refreshPendingRequests()
        Swal.fire('อนุมัติแล้ว', '', 'success')
      } catch (err) {
        console.error('approve error', err)
        Swal.fire('เกิดข้อผิดพลาด', '', 'error')
      }
    },

    async reject(item) {
      try {
        const asset = this.assets.find(a => a._id === item._id)
        if (!asset) return
        // First remove the asset from the report (backend)
        await this.$store.dispatch('Dashboard/removeAssetFromReport', {
          reportId: item.report,
          assetIds: [asset._id]
        })

        // Then remove only the targeted history entry that references this report
        const idx = Number(item.historyIndex)
        let updatedHistory = Array.isArray(asset.history) ? [...asset.history] : []
        if (Number.isInteger(idx) && updatedHistory[idx] && updatedHistory[idx].report === item.report) {
          updatedHistory.splice(idx, 1)
        } else {
          // fallback: remove one pending entry that matches amount and report
          const firstIdx = updatedHistory.findIndex(h => h.report === item.report && h.status === 'pending' && Number(h.amount || 0) === Number(item.amount || 0))
          if (firstIdx >= 0) {
            updatedHistory.splice(firstIdx, 1)
          } else {
            // if none found, keep original history
            updatedHistory = (asset.history || [])
          }
        }
        await this.$store.dispatch('Assets/update', { _id: asset._id, history: updatedHistory })

        // Log the action
        await this.$store.dispatch('Dashboard2/logCaseAction', {
          caseId: item.report,
          by: "ผู้ใช้ระบบ",
          assetId: asset._id,
          assetAction: "rejected",
          reason: `ไม่อนุมัติ ${Array.isArray(asset.title) ? asset.title.map(t=>t.value).join(", ") : asset.title}`
        })

        // Refresh local view
        this.refreshPendingRequests()
        Swal.fire('ไม่อนุมัติแล้ว', '', 'success')
      } catch (err) {
        console.error('reject error', err)
        Swal.fire('เกิดข้อผิดพลาด', '', 'error')
      }
    },
  },
  mounted() {
    this.$store.dispatch("Assets/assets");
    this.$store.dispatch("Assets/category");
    this.$store.dispatch("Dashboard/reports");
    this.$store.dispatch("Auth/fetchUsers")
      console.log("👥 [Asset] SelectedUser:", this.selectedUser);
  }
};
</script>

<style scoped>
.inactive-row {
  background-color: #f8d7da;
  color: #721c24;
}
::v-deep .modal-rounded .modal-content {
  border-radius: 1rem !important;
}

</style>
